import React from 'react';
import { SyncOutlined } from '@ant-design/icons';

const NavRefresh = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <button onClick={handleRefresh} style={buttonStyle}>
      <SyncOutlined style={iconStyle} />
    </button>
  );
};

const buttonStyle = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  width: '36px',
  height: '36px',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 1,
};

const iconStyle = {
  color: 'gray', 
  fontSize: '20px', 
};

export default NavRefresh;
